export default __webpack_public_path__ + "static/media/aerial_noises_white.a08f8d83.svg";